export enum FilterType {
  AND = 'AND',
  OR = 'OR',
}
